export function SET_ORDER_EVENTS(state, events) {
  state.ordersEvents = events;
}

export function SET_ORDER_TO_UPDATE(state, order) {
  state.orderToUpdate = order;
}

export function SET_PRODUCT_SELECTED(state, product) {
  state.productSelected = product;
}

export function SET_DELIVERY_OP_TO_UPDATE(state, delivery) {
  state.deliveryToUpdate = delivery;
}

export function SET_CALENDAR_SELECTION(state, order) {
  state.calendarSelection = order;
}

export function SET_CALENDAR_NEW_EVENT(state, event) {
  state.newEventCalendar = event;
}